var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassyRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1456 1552",
    width: 1280,
    height: 1280,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h1456v1552h-1456z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h1456v232l-12 3-9 1h-59v31l-3 11-8 9-9 4-5 1h-31v-34l3-9 5-6 10-6 4-1 33-1v-54l-55-1-1-111h-110l-1 59-2 13-4 9-7 11-10 9-14 7-12 3-6 1-1 31-3 10-7 8-9 5-6 1h-31v-34l4-10 4-5 10-6 4-1 33-1v-54h-54l-3 16-8 16-9 10-13 8-15 5h-8l-2 14-4 10-7 12-7 7-11 7-9 4-10 2h-7l-1-55-55-1v116l-2 13-4 9-7 11-9 8-11 6-13 5-8 1-1 1-2 12-5 12-7 11-7 7-14 8-9 3-6 1-342 1-1 114-3 16-7 14-9 10-13 8-11 4-12 2-3 16-4 9-7 11-10 9-14 7-18 4-1 59-2 13-4 9-7 11-10 9-16 8-10 2h-7l-1-55-55-1v-9l4-14 7-12 10-10 14-8 11-3 65-1v-54h-110l-3 16-4 9-7 11-10 9-12 6-9 3-11 2-1 30-3 10-5 7-7 5-9 3-31 1v54l55 1v61l-2 12-4 10-8 11-8 7-12 7-13 4-8 1-3 16-4 9-7 11-10 9-16 8-10 2h-63v56h168v60l-3 16-5 10-7 9-8 7-14 7-6 2-12 2-1 31-3 10-8 9-9 4-5 1h-31v-34l3-9 5-6 7-5 7-2 33-1v-54h-110l-3 16-8 16-9 10-12 8h-1z",
    fill: "#201E1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1260,179)",
    d: "m0 0 4 1v168h56v224l55-1 1-33 3-9 6-7 9-5 4-1h34v29l-3 12-6 8-8 5-7 2h-32v56l56-1-1-4 3-12 8-16 7-8 5-5h2v46h-24v60l-3 16-5 10-7 9-8 7-16 8-10 2-62 1-3 16-4 9-7 11-10 9-16 8-8 2h-8l-2 14-4 10-7 12-7 7-11 7-10 4-15 3-1 55 54-1 2 1v9l-4 13-6 11-9 10-11 7-13 5-12 2-1 60-2 12-4 9-7 11-10 9-16 8-16 3-1 60-2 12-4 9-7 11-7 7-14 8-9 3-6 1h-175v-119l3-14 6-11 9-10 9-7 11-5 8-2 66-1v-33l4-10 4-5 7-5 7-2h34v31l-2 8-3 6-8 7-6 3-5 1-31 1-2 13-4 11-8 12-7 7-11 7-11 4-13 2v54h111v-9l4-13 7-12 10-10 14-8 11-3 9-1v-166l-111-1v10l-5 14-7 12-8 8-14 8-9 3-6 1-118 1-1 60v167l-3 15-7 14-9 10-11 7-13 5-7 1h-62v-9l4-14 7-12 5-6 8-6 14-7 14-3h4l-1-54-55-1-1-55-223-1v-9l5-16 7-11 9-9 15-8 10-3 8-1 1-1 3-15 5-11 6-9 8-8 16-8 10-3 9-1-1-4 1-29 4-10 7-7 7-4 4-1h34v31l-3 10-4 6-8 6-9 3-31 1v54h55v-8l4-13 5-10 7-9 11-8 15-6 13-2 1 1v56l56-1v-8l4-14 7-12 10-10 12-7 9-3 13-2v-110l-111-1v-9l5-16 7-11 9-9 14-8 11-3 66-1v-8l4-14 7-12 10-10 12-7 14-4 9-1v-33l4-10 4-5 10-6 4-1h34v30l-2 9-6 9-9 6-6 2-32 1-1 55 54-1 2 1v8l-3 11-7 14-9 10-11 7-13 5-12 2v54h111v-9l4-13 7-12 5-6 13-9 12-5 15-2v-8l4-14 7-12 10-10 12-7 9-3 13-2 2-13 5-13 7-10 8-8 14-8 11-3 10-1v-8l4-14 7-12 5-6 8-6 14-7 14-3h4l-1-54-55-1v10l-5 14-7 12-8 8-11 7-12 4-7 1h-62v-119l3-14 6-11 9-10 9-7 11-5 8-2h66v8l-4 15-9 14-7 7-14 8-13 4-8 1v54h55v-9l4-13 7-12 6-7 10-7 11-5 14-3h4l-1-110-111-1v-9l4-14 7-12 10-10 14-8 11-3 10-1-1-54-111-1v-9l4-14 7-12 10-10 14-8 11-3 10-1v-8l4-14 7-12 5-6 13-9 12-5 15-2v-8l4-14 7-12 10-10 10-6 15-5z",
    fill: "#201E1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h368v12h55l1 1v54l-1 1-65 1-12 4-13 7-3 3h-2l-2 4-7 10-5 13-2 13-10 2-13 4-12 7-9 9-8 14-3 13-1 64h55l1 1v54l-1 1h-166l-1-1v-54l1-1 32-1 10-4 7-6 4-9 1-5 1-31-34 1-12 6-6 7-3 8-1 33-9 2-14 4-12 7-9 9-7 12-4 14-1 8-10 2-13 4-12 7-9 9-8 14-3 14-1 63 62-1 11-2 16-8 10-9 8-13 4-15 1-7 1-1 118-1 13-3 13-7 10-9 8-13 4-14 1-8 1-1 61-1 11-2 16-8 10-9 8-14 4-12 1-9 1-1h54l1 1v54l-1 1-13 2-13 5-10 7-7 7-7 12-3 9-2 13-10 2-13 4-12 7-9 9-7 12-4 12-1 10-1 1h-15l-18 1-12 6-6 7-3 8-1 33-9 2-14 4-12 7-9 9-7 12-4 14-1 8-2 1-64 1-13 4-12 7-9 9-8 16-3 8-1 10-2 1-33 1-10 5-5 5-3 5-2 6-1 34 32-1 11-4 5-4 6-12 1-4 1-31h55l1 1v54l-1 1-33 1-8 3-9 8-4 9-1 34-9 2-14 4-12 7-9 9-7 12-4 14-1 8-10 2-13 4-12 7-9 9-7 12-4 13-1 9-1 1h-31z",
    fill: "#FEFEFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(583,460)",
    d: "m0 0h65v56h56v8l-3 11-7 14-9 10-11 7-13 5-12 2-1 55h56v8l-3 11-7 14-9 10-11 7-9 4-12 2-60 1-3 16-8 16-9 10-11 7-9 4-11 2h-62v56h168v57l-2 15-5 12-8 11-7 6-16 8-12 3-5 1-1 30-3 10-5 7-10 6-6 2h-32v31l-3 10-6 8-7 4-8 3-31 1-1 60-2 12-4 9-7 11-7 7-14 8-9 3-5 1-63 1-3 16-4 9-7 11-7 7-14 8-9 3-5 1-119 1-3 16-4 9-7 11-7 7-14 8-9 3-6 1h-63v-9l4-14 7-12 10-10 14-8 11-3 10-1v-9l5-15 7-11 4-5 10-7 10-5 10-3 8-1 1-1 3-15 5-12 7-9 7-7 12-7 13-4 9-1 1 1 1 55h55v-9l4-13 7-12 5-6 13-9 12-5 5-1 66-1v-9l4-13 7-12 10-10 12-7 14-4 9-1v-33l4-10 4-5 10-6 4-1 33-1 1-33 4-10 4-5 7-5 7-2 33-1v-54h-166l-1 115-2 13-4 9-7 11-10 9-16 8-10 2h-63l-1-55-55-1v-64l3-13 6-11 9-10 9-7 11-5 7-2 11-1v-8l4-14 7-12 5-6 13-9 10-4 14-3 3 1v56l55-1 1-174 3-14 6-11 9-10 8-6 11-5 11-3 8-1-1-4 3-12 4-10 7-10 8-8 14-8 11-3 66-1-1-54-55-1v-9l5-16 7-11 9-9 14-8z",
    fill: "#201E1F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1317,1131)",
    d: "m0 0 3 1v61l-3 15-5 10-7 9-8 7-16 8-16 3-1 111 56-1v-63l3-13 6-11 9-10 9-7 12-5 16-3 1-63 3-13 6-11 9-10 9-7 12-5 14-3 3 1v61l-2 12-4 9-7 11-10 9-16 8-16 3-1 111h80v196h-360v-35l3-14 6-11 9-10 8-6 10-5 12-3 8-1v-10l6-16 7-10 5-5 9-7 12-5 13-3h4l-1-110-55-1v-64l3-13 6-11 9-10 9-7 11-5 8-2 66-1v-9l4-13 7-12 5-6 13-9 12-5z",
    fill: "#201E1F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1037,291)",
    d: "m0 0 3 1v112h56v61l-3 15-5 10-7 9-8 7-16 8-9 2-55 1-8-1-2 14-7 16-7 9-8 7-16 8-10 2-118 1-1 111 54-1 2 1v8l-3 11-7 14-9 10-11 7-9 4-11 2h-118v-9l4-14 7-12 6-7 10-7 11-5 14-3h4v-118l3-14 6-11 9-10 8-6 10-5 10-3 8-1 1-1 3-15 5-12 7-9 7-7 14-8 12-3 9-1v-33l4-10 7-7 10-5 33-1h2v-10l6-16 7-10 8-8 14-8 11-3 9-1 3-17 7-14 9-10 9-7 8-4 11-3z",
    fill: "#201E1F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1017)",
    d: "m0 0h439v180h-24v-112h-56l-1-55h-232l-12 3-11 6-10 9-7 10-5 13-2 13-2 1-13 2-12 5-10 7-7 7-7 12-4 13-1 9-2 1-64 1-13 4-12 7-9 9-7 12-4 12-1 10-1 1-65 1-13 4-12 7-9 9-7 12-4 14-1 9h55l1 1v54l-18 4-14 7-6 5h-2l-2 4-7 10-5 13-2 13-2 1h-54v-112h-56v-55l1-1 61-1 11-2 16-8 10-9 8-13 3-11 1-8 1-59 1-1h54l1 1v55l17-3 16-8 10-9 8-14 3-11 1-10 1-56 1-1 60-1 12-2 14-7z",
    fill: "#FEFEFE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(670,1244)",
    d: "m0 0h34v31l-2 8-3 6-8 7-11 4h-32v112l56-1v-63l3-13 6-11 9-10 9-7 12-5 13-3 4 1v228l-3 16-4 8h-273v-35l3-14 6-11 9-10 9-7 11-5 16-3h2v-8l4-14 7-12 5-6 13-9 12-5 11-2h4l-1-54-55-1v-9l4-14 7-12 10-10 14-8 11-3 65-1 1-33 4-10 4-5 7-5z",
    fill: "#201E1F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(536)",
    d: "m0 0h168v11l-1 1-64 1-12 3-11 6-10 9-7 10-5 14-2 13h55l1 1v166l-21 5-14 8-5 4-9 13-5 13-2 13-2 1-13 2-12 5-10 7-5 5-7 10-5 13-2 13-2 1h-53l-1-1v-54l6-2 11-2 16-8 10-9 8-13 3-12 1-7 1-59 1-1 16-3 16-8 10-9 8-14 3-9 2-13h-56l-1-29v-52z",
    fill: "#FEFEFE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1265,1412)",
    d: "m0 0h166l1 1v139h-168l-1-19v-102l1-18z",
    fill: "#FEFEFE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1030,1356)",
    d: "m0 0h122v8l-4 14-6 11-9 10-11 7-9 4-10 2-62 1-3 16-4 9-7 11-10 9-16 8-9 2-63 1-3 16-4 10-8 11-9 8-16 8-11 2h-62v-9l4-14 7-12 11-11 16-8 7-2 11-1v-8l3-11 6-12 9-10 9-7 11-5 8-2 66-1v-9l4-13 7-12 5-6 8-6 14-7z",
    fill: "#201E1F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(191,1468)",
    d: "m0 0h65v56h168v7l-4 15-3 6h-377l2-5 9-10 10-7 12-5 5-1 37-1h28l3-16 5-12 7-9 7-7 14-8z",
    fill: "#201E1F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(925,1243)",
    d: "m0 0 3 1 1 55h54l1-33 4-10 4-5 7-5 7-2h34v31l-2 8-4 7-7 6-6 3-5 1-31 1-2 12-3 10-9 14-7 7-11 7-12 4-6 1h-119v-9l4-14 7-12 10-10 14-8 11-3 10-1v-8l4-14 7-12 10-10 12-7 13-4z",
    fill: "#201E1F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(246,1244)",
    d: "m0 0h122v9l-5 16-8 12-7 7-14 8-9 3-6 1-62 1-3 16-4 9-7 11-10 9-14 7-18 4-1 31-3 10-7 8-9 5-5 1h-32v-34l4-10 7-7 7-4 4-1 33-1 1-63 3-13 6-11 9-10 9-7 11-5z",
    fill: "#201E1F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(166,12)",
    d: "m0 0h33l1 1v30l-3 10-6 8-11 6-4 1h-29l-2 1-1 60-3 14-7 14-9 10-14 8-12 4-10 2-2 13-4 11-8 12-7 7-14 8-9 3-7 1h-38v-48l17-7 5-1 66-1v-63l3-13 6-11 9-10 8-6 10-5 11-3 9-1v-33l3-9 6-7 9-5z",
    fill: "#201E1F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(424,68)",
    d: "m0 0h55l1 1v110l-18 4-14 7-6 5h-2l-2 4-7 10-5 13-2 13-2 1h-53l-1-1v-54l1-1 16-3 16-8 10-9 8-13 3-11 1-7z",
    fill: "#FEFEFE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(533,1131)",
    d: "m0 0 3 1v118l-3 14-5 10-7 9-8 7-16 8-11 2h-62v-9l4-14 7-12 11-11 16-8 14-3h4v-63l3-13 6-11 9-10 9-7 8-4 11-3z",
    fill: "#201E1F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(110,1300)",
    d: "m0 0h34v31l-3 10-4 6-9 6-8 3h-32v31l-2 8-6 9-7 5-9 3-31 1-1 60-3 15-5 10-7 9-8 7-9 5v-99l16-6 13-3h3v-33l4-10 7-7 10-5 34-1 1-33 4-10 5-6 9-5z",
    fill: "#201E1F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1429,291)",
    d: "m0 0 3 1v56h24v112h-24l-1-55-55-1v-63l3-14 6-11 9-10 9-7 12-5z",
    fill: "#201E1F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1310,964)",
    d: "m0 0h66v60l-3 16-5 10-7 9-8 7-16 8-10 2h-7l-1-55-55-1v-9l4-14 7-12 10-10 14-8z",
    fill: "#201E1F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(302,1356)",
    d: "m0 0h122v8l-3 11-7 14-9 10-11 7-9 4-11 2h-118v-9l5-16 7-11 9-9 14-8z",
    fill: "#201E1F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(190,404)",
    d: "m0 0h66v8l-4 15-9 14-7 7-14 8-9 3-7 1h-62v31l-3 10-6 8-8 5-7 2h-32v-34l4-10 4-5 10-6 4-1 34-1v-10l5-14 7-11 9-9 14-8z",
    fill: "#201E1F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(638,1132)",
    d: "m0 0h66v8l-4 15-9 14-7 7-11 7-15 5-9 1-3 16-4 9-7 11-7 7-14 8-9 3-13 1v-64l3-13 5-10 11-12 10-7 12-5z",
    fill: "#201E1F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(368,404)",
    d: "m0 0h55l1 1v54l-18 4-14 7-8 6-7 10-5 10-3 11-1 8-2 1h-53l-1-1v-54l1-1 31-1 11-4 6-5 5-10 1-5z",
    fill: "#FEFEFE"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(928,404)",
    d: "m0 0h55l1 1v54l-18 4-14 7-8 6-9 13-5 13-2 13-2 1h-53l-1-1v-54l1-1 31-1 11-4 7-6 4-9 1-4z",
    fill: "#FEFEFE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(481,628)",
    d: "m0 0h110l1 1v54l-1 1h-111v-55z",
    fill: "#FEFEFE"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(32,796)",
    d: "m0 0h55l1 1v54l-15 3-10 4-11 7-8 8-8 16-3 9-1 9-1 1h-31v-56l12-2 10-5 6-8 3-10z",
    fill: "#FEFEFE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(278,12)",
    d: "m0 0h33l1 1v29l-2 9-6 9-10 6-7 2h-31v32l-3 10-7 8-10 5-4 1h-32v-34l4-10 7-7 11-5 25-1h8l1-33 4-10 4-5 10-6z",
    fill: "#201E1F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1454,806)",
    d: "m0 0h2v209l-7 3-11 2h-6v-175l3-14 6-11 9-10z",
    fill: "#201E1F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(648,1468)",
    d: "m0 0h55l1 1v83h-56z",
    fill: "#FEFEFE"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1152,1468)",
    d: "m0 0h56v55l-2 1h-54z",
    fill: "#FEFEFE"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(649,292)",
    d: "m0 0h54l1 1v54l-1 1h-55v-55z",
    fill: "#FEFEFE"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1153,796)",
    d: "m0 0h54l1 1v54l-1 1h-54l-1-1v-54z",
    fill: "#FEFEFE"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(705,12)",
    d: "m0 0h54l1 1v54l-3 1h-53v-55z",
    fill: "#FEFEFE"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(28,1187)",
    d: "m0 0 4 1v61l-3 15-5 10-7 9-8 7-9 5v-99l18-7z",
    fill: "#201E1F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1006,572)",
    d: "m0 0h34v31l-2 8-3 6-8 7-6 3-5 1h-32v-34l4-10 4-5 7-5z",
    fill: "#201E1F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(446,1412)",
    d: "m0 0h34v31l-2 8-3 6-8 7-7 3-5 1h-31v-34l4-10 5-6 9-5z",
    fill: "#201E1F"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1342,852)",
    d: "m0 0h34v30l-2 9-5 8-6 5-6 3-5 1h-32v-34l4-10 5-6 9-5z",
    fill: "#201E1F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1342,1468)",
    d: "m0 0h34v29l-2 10-4 7-7 6-6 3-6 1h-30l-1-1v-32l3-10 5-6 7-5z",
    fill: "#201E1F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(144,1524)",
    d: "m0 0h55l1 1v27h-63l3-9 3-10z",
    fill: "#FEFEFE"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(537,1524)",
    d: "m0 0h54l1 1v27h-63l5-15 2-12z",
    fill: "#FEFEFE"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h121l-1 3-15 7-12 2h-93z",
    fill: "#201E1F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(29,515)",
    d: "m0 0 3 1v8l-3 11-7 14-9 10-12 8h-1v-51z",
    fill: "#201E1F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1037,1523)",
    d: "m0 0 3 1v28h-48l2-5 9-10 10-7 10-4z",
    fill: "#201E1F"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(872)",
    d: "m0 0h56v11l-1 1h-54l-1-1z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassyRounded);
export default __webpack_public_path__ + "static/media/classy-rounded.5c3353d6a831a2722fdfa052199df75a.svg";
export { ForwardRef as ReactComponent };